<template>
  <div class="main-navigation">
    <ul>
      <li class="menu-item" v-for="item in mainNavigation" :key="item.name" :class="{active: item.name === activeItem}" @click="changeTreeView(item.name)">
        <div class="menu-item--image">
          <img :src="item.image" :alt="item.name">
        </div>
        <span class="menu-item--name">{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'CurrentDisplay',
  data () {
    return {
      activeItem: 'Berichten',
      mainNavigation: [
        {
          name: this.$t('mainNav.documents'),
          image: require('../../assets/img/navigation/documenten-module.svg'),
          link: '',
          active: false
        },
        {
          name: this.$t('mainNav.management'),
          image: require('../../assets/img/navigation/beheer-module.svg'),
          link: '',
          active: false
        },
        {
          name: this.$t('mainNav.messages'),
          image: require('../../assets/img/navigation/berichten-module.svg'),
          link: '',
          active: true
        },
        {
          name: this.$t('mainNav.contacts'),
          image: require('../../assets/img/navigation/contacten-module.svg'),
          link: '',
          active: false
        },
        {
          name: this.$t('mainNav.procedures'),
          image: require('../../assets/img/navigation/procedures-module.svg'),
          link: '',
          active: false
        }
      ]
    }
  },
  methods: {
    changeTreeView (name) {
      let self = this
      self.activeItem = name
    }
  }
}
</script>

<style lang="scss">

  .main-navigation {
    width: calc(100% - 50px);
    height: 250px;
    display: inline-block;
    border-top: 3px solid #eee;
  }

  .menu-item {
    width: 100%;
    height: 50px;
    line-height: 50px;

    &:hover {
      cursor: pointer;
      background-color: #f7f7f7;

      .menu-item--name { color: #212121; }
    }

    &--image {
      width: 50px;
      height: 50px;
      float: left;
      padding: 16px;

      img {
        height: 18px;
        float: left;
        vertical-align: middle;
      }
    }

    &--name {
      width: calc(100% - 50px);
      float: left;
      color: #58585b;
      font-size: 13px;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      padding-right: 15px;
      text-overflow: ellipsis;
    }

    &.active {
      background-color: #eee;

      .menu-item--name { color: #58585b; }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mainNav/mainNav.vue